import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_NAME } from '../../constants/site';
import { buildCanonicalUrl, buildOgImageUrl } from '../../constants/seo';

/**
 * Shared SEO meta tags for public pages (Google Search, Open Graph, Twitter).
 */
export default function PageHelmet({
  title,
  description,
  path = '/',
  image,
  type = 'website',
  robots = 'index, follow',
  keywords,
  jsonLd,
  productPrice,
  productCurrency = 'JMD',
}) {
  const canonicalUrl = buildCanonicalUrl(path);
  const ogImage = buildOgImageUrl(image);
  const jsonLdItems = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_JM" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {productPrice != null && (
        <>
          <meta property="product:price:amount" content={String(productPrice)} />
          <meta property="product:price:currency" content={productCurrency} />
        </>
      )}

      {jsonLdItems.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
